export default __webpack_public_path__ + "static/media/Leggings of Black Whispers.4c476332.jpg";